// extracted by mini-css-extract-plugin
module.exports = {"col":"soMtk","title":"svPuz","subtitle":"tszpm"};